import { render, staticRenderFns } from "./allocutions_list.vue?vue&type=template&id=0a6e2a32&"
import script from "./allocutions_list.vue?vue&type=script&lang=js&"
export * from "./allocutions_list.vue?vue&type=script&lang=js&"
import style0 from "./allocutions_list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports